let AlbumAnswer = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.delete();
        this.sort();
    },

    delete: function () {
        $('.delete-album-answer').click(function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/albums/answers/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'Record has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form: function () {
        let _this = this;
        const albumAnswerForm = $('#albumAnswerForm');

        if (albumAnswerForm.length) {
            let submitBtn = Ladda.create(albumAnswerForm.find('[type=submit]')[0]);

            albumAnswerForm.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/albums/' + response.data.album_id + '/questions/' + response.data.id + '/edit');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });

            $(document).on('click', 'input[type=checkbox]', function () {
                $('input[type=checkbox]').prop('checked', false);
                $(this).prop('checked', true);
            });

            const answersContainer = $('#answersContainer');
            let answersCount = $('.answer').length;

            $(document).on('click', '.btn-add-answer', function () {
                let html = '<div class="form-group answer">\n' +
                    '                    <label for="albumAnswer' + answersCount + 'Title">Title</label>\n' +
                    '                    <div class="input-group">\n' +
                    '                       <input type="text" class="form-control" name="answers[' + answersCount + '][title]" id="albumAnswer' + answersCount + 'Title" value="" placeholder="Title" required>\n' +
                    '                       <div class="input-group-addon no-padding">\n' +
                    '                       <button type="button" class="btn btn-danger btn-delete-answer"><i class="fa fa-trash"></i></button>\n' +
                    '                    </div>\n' +
                    '                    </div>\n' +
                    '                    <input type="hidden" name="answers[' + answersCount + '][id]" value="">\n' +
                    '                    <label><input type="checkbox" name="answers[' + answersCount + '][is_correct]" value="1"> Is Correct</label>\n' +
                    '                </div>';
                answersContainer.append(html);
                answersCount++;
            });

            $(document).on('click', '.btn-add-sortable-answer', function () {
                let html = '<div class="answer row">\n' +
                    '                        <div class="form-group col-sm-8">\n' +
                    '                            <label for="albumAnswer' + answersCount + 'Title">Title</label>\n' +
                    '                            <input type="text" class="form-control" name="answers[' + answersCount + '][title]" id="albumAnswer' + answersCount + 'Title" value="" placeholder="Title" required>\n' +
                    '                            <input type="hidden" name="answers[' + answersCount + '][id]" value="">\n' +
                    '                        </div>\n' +
                    '                        <div class="form-group col-sm-2">\n' +
                    '                            <label for="albumAnswer' + answersCount + 'Order">Order</label>\n' +
                    '                            <input type="text" class="form-control" name="answers[' + answersCount + '][order]" id="albumAnswer' + answersCount + 'Order" value="" placeholder="Order" required>\n' +
                    '                        </div>\n' +
                    '                        <div class="form-group col-sm-2 pt-2 text-right">\n' +
                    '                            <button type="button" class="btn btn-danger btn-delete-answer"><i class="fa fa-trash"></i></button>\n' +
                    '                        </div>\n' +
                    '                    </div>';
                answersContainer.append(html);
                answersCount++;
            });

            $(document).on('click', '.btn-delete-answer', function () {
                $(this).closest('.answer').remove();
            });
        }

        $('#answers').on('draw.dt', function () {
            _this.delete();
        });
    },

    sort() {
        const table = $('#albumAnswers');
        table.sortable({
            items: 'tbody tr',
            stop: function (e, ui) {
                let order = [];
                const rows = ui.item.closest('table').find('tbody tr');

                rows.each((key, row) => {
                    order.push($(row).data('id'));
                });

                console.log(order);

                $.post('/albums/answers/reorder', {
                    order
                }, response => {
                });
            }
        });
    },
};

$().ready(function () {
    window.AlbumAnswer = AlbumAnswer;
    window.AlbumAnswer.init();
});
